<template>
  <v-container>
    <v-container class="ma-0 pa-0 d-flex">
      <h1>Клиенты</h1>

      <v-spacer></v-spacer>

      <customer-create></customer-create>
    </v-container>
    <v-expansion-panels focusable>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <span>
            Фильтр
            <v-badge v-if="isActiveFilter"
              color="green" 
              dot 
              inline
            ></v-badge>
          </span> 
        </v-expansion-panel-header>

        <v-expansion-panel-content>
          <v-form ref="filterForm" :disabled="loadingList"><v-row>
          
           <v-col cols="12" sm="4">
            <v-autocomplete 
              label="Сайт" 
              v-model="siteId"
              :items="sitesSelectData"
              clearable
              filled
            >
            </v-autocomplete>
          </v-col>

          <v-col cols="12" sm="4">
            <v-select 
              label="Статус"
              v-model="status"
              :items="statuses"
              multiple
              clearable
              filled
            >
              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0">{{ item.text }} </span>
                <span
                  v-if="index === 1"
                  class="grey--text caption"
                >(+{{ status.length - 1 }} др.)</span>
              </template>
            </v-select>
          </v-col>

          <v-col cols="12" sm="4">
            <v-text-field 
              label="Имя, телефон, email, комментарий"
              v-model="text"
              clearable
              filled
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="4">
            <v-menu
              v-model="createdDatesMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="createdDates[0] && createdDates[1] ? createdDates[0] + ' ~ ' + createdDates[1] : ''"
                  label="Дата создания"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  filled
                ></v-text-field>
              </template>
              <v-date-picker v-model="createdDates" no-title scrollable range>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="createdDates = ['', '']; createdDatesMenu = false;">Отмена</v-btn>
                <v-btn text color="primary" :disabled="!createdDates[1]" @click="createdDatesMenu = false;">ОК</v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" sm="4">
             <v-menu
              v-model="updatedDatesMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="updatedDates[0] && updatedDates[1] ? updatedDates[0] + ' ~ ' + updatedDates[1] : ''"
                  label="Дата изменений"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  filled
                ></v-text-field>
              </template>
              <v-date-picker v-model="updatedDates" no-title scrollable range>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="updatedDates = ['', '']; updatedDatesMenu = false;">Отмена</v-btn>
                <v-btn text color="primary" :disabled="!updatedDates[1]" @click="updatedDatesMenu = false;">ОК</v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" sm="4">
            <v-btn 
              color="primary" 
              text 
              @click="loadCustomers" 
              :loading="loadingList"
            >Загрузить</v-btn>
            <v-btn color="blue darken-1" text @click="clearFilter">Очистить</v-btn>
          </v-col>
          
        </v-row></v-form>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
   

  <v-container class="pa-0 ma-0 mt-3">
     <v-tabs>
      <v-tab>Клиенты </v-tab>
      <v-tab>Лиды</v-tab>

      <v-tab-item>
        <v-data-table
          :key="customersQueryKey"
          :headers="customerHeaders"
          :items="customers"
          :loading="loadingList"
          item-key="_id"
          class="elevation-1"
          loading-text="Данные загружаются... Пожалуйста, подождите."
        >
          <template v-slot:[`header.date`]="">
            Дата 
            <a style="color: #2196F3; border-bottom: 1px dashed #2196F3;" @click="changeSort()">
              {{ sort == 'created' ? 'создания' : 'редактирования' }}
            </a>
          </template>

          <template v-slot:[`item.date`]="{ item }">
            {{ (sort == 'created' ? item.createdAt : item.updatedAt) | localDatetime  }}
          </template>

          <template v-slot:[`item.id`]="{ item }">
            <div class="id-block">
              <customer-card :id="item.id"></customer-card>
              <template v-if="item.utm && item.utm.source">
                <!-- Иконка utm_source -->
                <img v-if="item.utm.source == 'instagram'" src="/icons/insta1.svg">
                <img v-if="item.utm.source == 'yandex'" src="/icons/yandex1.svg">
                <img v-if="item.utm.source == 'google'" src="/icons/google1.svg">
                <img v-if="item.utm.source == 'vk'" src="/icons/vk1.svg">
              </template>
            </div>
          </template>

          <template v-slot:[`item.phoneNumber`]="{ item }">
            <a :href="`tel:+7${item.phoneNumber}`">{{ item.phoneNumber }}</a>
          </template>

          <template v-slot:[`item.status`]="{ item }">
            <div>{{ item.statusText }}</div>
            <div style="font-size:10px;">{{ item.comment }}</div>
          </template>
        </v-data-table>
       
        <v-alert class="mt-3" type="warning" outlined dense v-if="customersCount != customers.length">
          <small>Показаны первые {{ customers.length }} записей (всего найдено {{ customersCount }}).
          Для просмотра остальных уточните критерии поиска с помощью фильтра.</small>
        </v-alert>
      </v-tab-item>

      <v-tab-item>
        <leads-table
          :leads="leads"
          :loading="loadingList"
        ></leads-table>
      </v-tab-item>

    </v-tabs>
  </v-container>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import DateTimeLocal from '../models/datetime';
import CustomerCreate from '../components/customers/CustomerCreate';
import CustomerCard from '../components/customers/CustomerCard';
import LeadsTable from '../components/customers/LeadsTable';
import { getTempId } from '../models/common';
 
export default {
  components: {
    CustomerCard,
    CustomerCreate,
    LeadsTable
  },

  data() {
    return {
      // Фильтр
      siteId: this.$store.state.customers.filter ? this.$store.state.customers.filter.siteId : null,
      status: this.$store.state.customers.filter && this.$store.state.customers.filter.status ? 
        this.$store.state.customers.filter.status.split(',') : null,
      text: this.$store.state.customers.filter ? this.$store.state.customers.filter.text : '',
      createdDates: this.$store.state.customers.filter && this.$store.state.customers.filter.start  ? 
        [
          DateTimeLocal.getISOFromDate(this.$store.state.customers.filter.start), 
          DateTimeLocal.getISOFromDate(this.$store.state.customers.filter.end), 
        ] : ['', ''],
      updatedDates: this.$store.state.customers.filter && this.$store.state.customers.filter.start_m  ? 
        [
          DateTimeLocal.getISOFromDate(this.$store.state.customers.filter.start_m), 
          DateTimeLocal.getISOFromDate(this.$store.state.customers.filter.end_m), 
        ] : ['', ''],
      sort: this.$store.state.customers.filter ? this.$store.state.customers.filter.sort : 'created',

      // Меню для выбора диапазонов дат (с - по)
      createdDatesMenu: false,
      updatedDatesMenu: false,

      customerHeaders: [
        {
          text: "ID",
          value: "id"
        },
        {
          text: "Изменен / создан",
          value: "date",
          sortable: false
        },
        {
          text: "Город",
          value: "site.city.name"
        },
        {
          text: "Телефон",
          value: "phoneNumber",
        },
        {
          text: "ФИО",
          value: "fullName"
        },
        {
          text: "Статус",
          value: "status"
        }
      ],
      leadHeaders: [],
    };
  },

  created() {
    document.title = 'Клиенты';
    this.$store.dispatch('sites/loadList');
    this.$store.dispatch('customers/loadList');
  },

  methods: {
    async loadCustomers() {
      this.$store.dispatch('customers/loadList', {
        siteId: this.siteId,
        status: this.status ? this.status.join(',') : '',
        text: this.text,
        start: String(DateTimeLocal.getStartDateFromISO(this.createdDates[0])),
        end: String(DateTimeLocal.getFinishDateFromISO(this.createdDates[1])),
        start_m: String(DateTimeLocal.getStartDateFromISO(this.updatedDates[0])),
        end_m: String(DateTimeLocal.getFinishDateFromISO(this.updatedDates[1])),
        sort: this.sort
      }).then(() => {
        
      });
    },

    clearFilter() {
      this.$refs.filterForm.reset();
      this.createdDates = ['', ''];
      this.updatedDates = ['', ''];
      this.loadCustomers();
    },

    changeSort() {
      this.sort = this.sort == 'created' ? 'updated' : 'created';
      this.loadCustomers();
    }
  },

  computed: {
    ...mapState('customers', ['customers', 'leads', 'statuses', 'customersCount', 'customersQueryKey']),
    ...mapGetters('sites', ['sitesSelectData']),
    ...mapGetters('customers', ['loadingList', 'isActiveFilter']),
  }
}
</script>

<style scoped>
.id-block {
  display: flex; 
  align-items: center;
}
.id-block img {
  height: 13px;
  margin-left: 2px;
}
</style>